import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import LoadingIcon from '../../../../../../assets/common/images/icon/loading.png';
import CautionIcon from '../../../../../../assets/common/images/icon/caution.png';
import { trans } from '../../../../../../localization';
import {
  ModalAction,
  ModalBody,
  ModalButton,
} from '../../../../../../components/Modal/Modal';
import {
  changeRestaurantOfOrder,
  startTransferringOrder,
  stopTransferringOrder,
} from '../actions';
import { isEmpty } from '../../../../../../utils/utils';

const LoadingSignal = () => (
  <div className="signal-verify-container">
    <img
      src={LoadingIcon}
      className="signal-verify loading-verify"
      alt="icon"
    />
  </div>
);

const InvalidSignal = () => (
  <div className="signal-verify-container">
    <img src={CautionIcon} className="signal-verify" alt="icon" />
  </div>
);

const VerifyingCriteria = ({ name }) => (
  <div className="verifying-criteria-container">
    <div className="verifying-criteria-name">{name}</div>
  </div>
);

class TransferOrderVerify extends Component {
  componentDidMount() {
    setTimeout(this.attemptChangeBranch, 3000);
  }

  attemptChangeBranch = () => {
    const {
      transferredOrder,
      selectedBranch,
      changeRestaurantOfOrderConnect,
    } = this.props;
    const { code } = transferredOrder || {};
    const { restaurant_id: restaurantId } = selectedBranch || {};

    if (!isEmpty(code) && !isEmpty(restaurantId)) {
      changeRestaurantOfOrderConnect(code, restaurantId);
    }
  };

  render() {
    const {
      transferredOrder,
      newBranchData,
      newBranchError,
      startTransferringOrderConnect,
      stopTransferringOrderConnect,
    } = this.props;
    const isVerifying = isEmpty(newBranchData) && isEmpty(newBranchError);
    const isVerifiedError = isEmpty(newBranchData) && !isEmpty(newBranchError);

    return (
      <Fragment>
        <ModalBody>
          {isVerifying && <LoadingSignal />}
          {isVerifiedError && <InvalidSignal />}

          <p className="verifying-text">
            {isVerifying && trans('verifying_transferred_branch')}
            {isVerifiedError &&
              trans('checking_condition_to_transfer_branch_failed')}
          </p>
          <p className="verifying-subtext">
            {isVerifiedError &&
              trans('please_come_back_and_choose_another_branch')}
          </p>

          <div className="list-verifying-criteria">
            {isVerifying && (
              <React.Fragment>
                <VerifyingCriteria
                  name={trans('checking_for_items_toppings')}
                />
                <VerifyingCriteria name={trans('checking_for_promotions')} />
              </React.Fragment>
            )}

            {isVerifiedError && (
              <VerifyingCriteria name={trans(newBranchError)} />
            )}
          </div>
        </ModalBody>

        {isVerifying && (
          <ModalAction>
            <ModalButton
              className="text-blue button-cancel"
              onClick={stopTransferringOrderConnect}
            >
              {trans('common_cancel')}
            </ModalButton>
          </ModalAction>
        )}

        {isVerifiedError && (
          <ModalAction>
            <ModalButton
              className="text-blue button-cancel"
              onClick={stopTransferringOrderConnect}
            >
              {trans('common_cancel')}
            </ModalButton>
            <ModalButton
              className="btn-blue button-confirm"
              onClick={() => startTransferringOrderConnect(transferredOrder)}
            >
              {trans('choose_another_branch')}
            </ModalButton>
          </ModalAction>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  transferredOrder: state.transferOrder.transferredOrder,
  selectedBranch: state.transferOrder.selectedBranch,
  newBranchData: state.transferOrder.newBranchData,
  newBranchError: state.transferOrder.newBranchError,
});

const mapDispatchToProps = {
  startTransferringOrderConnect: startTransferringOrder,
  stopTransferringOrderConnect: stopTransferringOrder,
  changeRestaurantOfOrderConnect: changeRestaurantOfOrder,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransferOrderVerify);



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/TransferOrder/components/TransferOrderVerify.jsx